import React from 'react';

function NotFound() {
  return (
    <div className="flex items-center justify-center w-full h-full">Not Found</div>
  );
}

export default NotFound;
